import _ from "lodash";
import produce from "immer";
import axios from "axios";
import strings from "../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../lib/common";

export const CREATE_CATALOGUE_ITEM = "productCatalogue/CREATE_CATALOGUE_ITEM";
export const UPDATE_CATALOGUE_ITEM = "productCatalogue/UPDATE_CATALOGUE_ITEM";
export const DELETE_CATALOGUE_ITEM = "productCatalogue/DELETE_CATALOGUE_ITEM";
export const RETRIEVE_CATALOGUE_ITEMS =
  "productCatalogue/RETRIEVE_CATALOGUE_ITEMS";

const CREATE_CATALOGUE_ITEM_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const UPDATE_CATALOGUE_ITEM_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const DELETE_CATALOGUE_ITEM_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const RETRIEVE_CATALOGUE_ITEMS_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const initialState = {
  // dictionary of dictionaries where the key is the group_id for the outer dictionary
  // and the catalogue_item_id is the key for the inner dictionary
  catalogueItems: {},

  // dictionary of dictionaries where the key is the supplier_id for the outer dictionary
  // and the catalogue_item_id is the key for the inner dictionary
  supplierCatalogueItems: {},
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CREATE_CATALOGUE_ITEM: {
        break;
      }

      case UPDATE_CATALOGUE_ITEM: {
        const catalogueItemId = _.get(
          action.catalogueItem,
          "catalogue_item_id"
        );

        if (action.supplierId) {
          draft.supplierCatalogueItems[action.supplierId][catalogueItemId] =
            action.catalogueItem;
        } else {
          draft.catalogueItems[action.groupId][catalogueItemId] =
            action.catalogueItem;
        }

        break;
      }

      case DELETE_CATALOGUE_ITEM: {
        break;
      }

      case RETRIEVE_CATALOGUE_ITEMS: {
        if (action.supplierId) {
          draft.supplierCatalogueItems[action.supplierId] = {};
        } else {
          draft.catalogueItems[action.groupId] = {};
        }

        action.catalogueItems.forEach((i) => {
          if (action.supplierId) {
            draft.supplierCatalogueItems[action.supplierId][
              i.catalogue_item_id
            ] = i;
          } else {
            draft.catalogueItems[action.groupId][i.catalogue_item_id] = i;
          }
        });
        break;
      }

      default: {
        break;
      }
    }
  });

export const createCatalogueItem = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_catalogue.createCatalogueItem",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_PRODUCT_CATALOGUE_CREATE_CATALOGUE_ITEM,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_CATALOGUE_ITEM });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_catalogue.createCatalogueItem",
                },
            history
          )
        );

        dispatch(
          retrieveCatalogueItems({
            values,
            successState: {
              context:
                "product_catalogue.createCatalogueItem.retrieveCatalogueItems",
            },
            errorState: (error) => ({
              ...error,
              context:
                "product_catalogue.createCatalogueItem.retrieveCatalogueItems",
              notificationType: "alert",
            }),
          })
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_CATALOGUE_ITEM_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_catalogue.createCatalogueItem",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const updateCatalogueItem = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_catalogue.updateCatalogueItem",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_PRODUCT_CATALOGUE_UPDATE_CATALOGUE_ITEM,
        values
      )
      .then((response) => {
        const groupId = _.get(values, "group_id");
        const supplierId = _.get(values, "supplier_id");
        const catalogueItem = _.get(response, "data.catalogue_item");

        dispatch({
          type: UPDATE_CATALOGUE_ITEM,
          groupId,
          supplierId,
          catalogueItem,
        });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_catalogue.updateCatalogueItem",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = UPDATE_CATALOGUE_ITEM_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_catalogue.updateCatalogueItem",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const deleteCatalogueItem = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_catalogue.deleteCatalogueItem",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_PRODUCT_CATALOGUE_DELETE_CATALOGUE_ITEM,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_CATALOGUE_ITEM });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_catalogue.deleteCatalogueItem",
                },
            history
          )
        );

        dispatch(
          retrieveCatalogueItems({
            values,
            successState: {
              context:
                "product_catalogue.deleteCatalogueItem.retrieveCatalogueItems",
            },
            errorState: (error) => ({
              ...error,
              context:
                "product_catalogue.deleteCatalogueItem.retrieveCatalogueItems",
              notificationType: "alert",
            }),
          })
        );
      })
      .catch((errorResponse) => {
        const error = DELETE_CATALOGUE_ITEM_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_catalogue.deleteCatalogueItem",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const retrieveCatalogueItems = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_catalogue.retrieveCatalogueItems",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_PRODUCT_CATALOGUE_RETRIEVE_CATALOGUE_ITEMS,
        values
      )
      .then((response) => {
        const groupId = _.get(values, "group_id");
        const supplierId = _.get(values, "supplier_id");
        const catalogueItems = _.get(response, "data.catalogue_items", []);

        dispatch({
          type: RETRIEVE_CATALOGUE_ITEMS,
          groupId,
          supplierId,
          catalogueItems,
        });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_catalogue.retrieveCatalogueItems",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        const error = RETRIEVE_CATALOGUE_ITEMS_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_catalogue.retrieveCatalogueItems",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};
